import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, ISubscriptionsQueryParams, ISubscriptionSummary } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<ISubscriptionSummary>, ISubscriptionsQueryParams>>(undefined as any);
